import { useState } from "react";
import CalculatedBoxes from "./CalculatedBoxes";
import Link from "next/link";
import { Typography } from "@mui/material";
import UserSection from "./UserSection";
import Announcements from "./Announcements";
import PaymentsDash from "./PaymentsDash";
import parse from "html-react-parser";

/** Headline + body for dashboard status banners (non-approved users). */
const DASHBOARD_STATUS_BANNERS = {
  needMoreInfo: {
    headline: "Let's finish your application!",
    body:
      "Hey there! Thanks for starting your Boho Market application. We just need a few more details before we can dive in. Complete the missing info and we'll be reviewing your application in no time!",
  },
  pending: {
    headline: "Your application is in!",
    body:
      "In the meantime, explore our other upcoming markets while we process your application. If you have any questions, feel free to reach out to our team at info@thebohomarket.com",
  },
  notApproved: {
    headline: "Unfortunately, it's not a good fit.",
    body:
      "Hi there! Thanks for applying to be a vendor at The Boho Market! While we couldn't approve your application at this time, we appreciate your interest. For any questions or to discuss further, feel free to email us at info@thebohomarket.com. Wishing you all the best!",
  },
  applicationFee: {
    headline: "We're missing your application fee!",
    body:
      "Hey there! Thanks for applying to be a vendor at The Boho Market! Just a heads up that your application fee of $10 is still outstanding. Once we receive that, we can jump right into reviewing your application.",
  },
  sponsor: {
    headline: "Other opportunities with The Boho Market.",
    body:
      "Hey there! Thanks for applying to be a vendor at The Boho Market! While your business might not be the perfect fit for us at this time, we do have another option! We offer exciting sponsorship opportunities that could be a great way to connect with our Boho audience. Interested in learning more? Reach out to us at info@thebohomarket.com!",
  },
};

function getDashboardStatusBanner(userData) {
  const status = userData?.account_status;
  if (!status || status === "approved") {
    return null;
  }

  const sponsorPath =
    status === "sponsor suggestion" ||
    (status === "rejected" && userData?.sponsor_opportunity === true);

  if (sponsorPath) {
    return DASHBOARD_STATUS_BANNERS.sponsor;
  }
  if (status === "application fee") {
    return DASHBOARD_STATUS_BANNERS.applicationFee;
  }
  if (status === "need more info") {
    return DASHBOARD_STATUS_BANNERS.needMoreInfo;
  }
  if (status === "incomplete") {
    return DASHBOARD_STATUS_BANNERS.needMoreInfo;
  }
  if (status === "pending") {
    return DASHBOARD_STATUS_BANNERS.pending;
  }
  if (status === "rejected") {
    return DASHBOARD_STATUS_BANNERS.notApproved;
  }
  return null;
}

export const DashBoardHead = ({
  userData,
  calculatedData,
  paymentInfo,
  children,
}) => {
  const [message, setMessage] = useState();
  const statusBanner = getDashboardStatusBanner(userData);

  return (
    <div className="wrapper-90">
      <div className="dashboard__head">
        <div className="dashboard__content__wagtail">
          <Typography variant="h3" color={"#2C333E"}>
            Welcome
            {userData?.first_name && userData?.first_name !== undefined
              ? `, ${userData.first_name}`
              : null}
          </Typography>
          <p className="dashboard__message">{message}</p>
        </div>
        {statusBanner ? (
          <div
            style={{
              textAlign: "center",
              color: "#2C333E",
              marginBottom: "1rem",
            }}
          >
            <Typography
              component="h2"
              variant="h4"
              sx={{ color: "#2C333E", fontWeight: 600, marginBottom: 1 }}
            >
              {statusBanner.headline}
            </Typography>
            <Typography
              component="p"
              variant="body1"
              sx={{ color: "#2C333E", maxWidth: "52rem", margin: "0 auto" }}
            >
              {statusBanner.body}
            </Typography>
          </div>
        ) : null}
        {userData?.account_status === "approved" ? (
          <p className="dashboard__message">
            {parse(userData?.announcement_info.portal_header)}
          </p>
        ) : null}
      </div>
      {(userData?.account_status === "incomplete" ||
        userData?.account_status === "need more info" ||
        userData?.account_status === "application fee") && (
        <CalculatedBoxes calculatedData={calculatedData} userData={userData} />
      )}

      <div className="dashboard__content__main">
        <div className="dashboard__content__head__title">
          <UserSection
              userData={userData}
            ></UserSection>
        </div>
        <div className="dashboard__content__head__title">
          <Announcements
          announcementInfo={userData?.announcement_info}/>
        </div>
        <div className="dashboard__content__head__title">
          <PaymentsDash
              ></PaymentsDash>
        </div>
      </div>
      <div className="dashboard__content__head">
        <Typography variant="h3" color={"#2C333E"}>All Boho Events</Typography>{" "}
        <Link href="/events/all-events" prefetch={false}>
          <a>View All Boho Events</a>
        </Link>
      </div>
      {children}
      <div className="dashboard__content__foot">
        <Link href="/events/all-events" prefetch={false}>
          <a>View All Boho Events</a>
        </Link>
      </div>
    </div>
  );
};

export default DashBoardHead;